import React, { useMemo } from "react";

// component
import SelectReact from "react-select";

// types
import type { StylesConfig } from "react-select/dist/declarations/src/styles";
import type { StateManagerProps } from "react-select/dist/declarations/src/useStateManager";

/**
 * react-select styled for different themes.
 * used for synchronous operations, there is a built-in search by options.
 *
 * @param restParam (all props that are available for react select)
 * @returns JSX.Element} component CustomReactSelect.
 */
export function Select({ ...restParam }: StateManagerProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const customStyles: StylesConfig<any> = useMemo(
    () => ({
      input: (provided) => ({
        ...provided,
        width: "fit-content",
        color: "#fdfdfd",
        margin: 0,
        padding: 0,
      }),

      valueContainer: (provided) => ({
        ...provided,
        padding: "9px 16px",
      }),

      control: (provided) => ({
        ...provided,
        background: "transparent",
        border: `1px solid #9B9B9B`,
        borderRadius: "6px",
        color: "#9B9B9B",
        fontFamily: "Inter, sans-serif",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        cursor: "pointer",
      }),

      menu: (provided) => ({
        ...provided,
        zIndex: 10,
        backgroundColor: "gray",
      }),

      option: (provided, { isDisabled, isFocused }) => ({
        ...provided,
        paddingLeft: isDisabled ? "6px" : "18px",
        cursor: isDisabled ? "not-allowed" : "default",
        textTransform: isDisabled ? "uppercase" : undefined,
        backgroundColor: isFocused ? "rgba(255,255,255, 0.5)" : "gray",
        color: "#FFF",
      }),

      singleValue: (provided) => ({
        ...provided,
        color: "#ffffff",
        fontFamily: "Inter, sans-serif",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
      }),

      multiValue: (provided) => ({
        ...provided,
        backgroundColor: "transparent",
        color: "#ffffff",
        margin: 0,
      }),

      multiValueLabel: (provided) => ({
        ...provided,
        color: "#ffffff",
        fontFamily: "Inter, sans-serif",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        padding: 0,
      }),

      placeholder: (provided) => ({
        ...provided,
        color: "#9B9B9B",
        margin: 0,
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
      }),

      indicatorsContainer: (provided) => ({
        ...provided,
        padding: "0",
      }),

      // To reset default styles
      indicatorSeparator: () => ({}),
    }),
    []
  );

  return <SelectReact styles={customStyles} {...restParam} />;
}
